import React, { useContext } from 'react';
import { FeaturesContext, IFeatures } from 'contexts/features';
import EmberPage from 'components/dynamic-page/ember-page';
import NewHomesHeader from './components/header';
import NewHomesVIP from './components/vip-section';
import ProjectListingSection from './components/project-listing-section';
import styles from './style.module.scss';

import type { GetProjectsResponse } from '@zoocasa/pre-construction';

export default function NewHomes({ vip, available, upcoming }: GetProjectsResponse) {
  const { features } = useContext(FeaturesContext) as IFeatures;

  if (!features.usePreCon) {
    return <EmberPage />;
  }

  return (
    <div className={styles.component}>
      <NewHomesHeader />
      <div className={styles.container}>
        {!!vip.length && <NewHomesVIP listings={vip} />}
      </div>
      <div className={styles['listing-section']}>
        {!!available.length &&
          <ProjectListingSection
            listings={available}
            title="Buy Today"
            navigateToPath='/newhomes/buy-today'
          />
        }
        {!!upcoming.length &&
          <ProjectListingSection
            listings={upcoming}
            title="Coming Soon"
            navigateToPath='/newhomes/coming-soon'
          />
        }
        <div className={styles.container}>
          <p className={styles.disclaimer}>Disclaimer: Zoocasa do not represent the builder. The information is for reference only and subject to change without notice.</p>
        </div>
      </div>
    </div>
  );
}
